// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"55":"0c733c86","69":"f183fc18","98":"167bd731","219":"c37e2534","261":"c6ae6c6e","320":"14e5588f","443":"89a0bea5","570":"e6a11305","633":"878e0c68","815":"813da504"}[chunkId] + ".js";
};